"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/SoundAmplitude.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _utils = require('shared/utils');

const clampOnScale = _utils.clamp.call(void 0, 0, 1)

const parseRawLevels = (rawLevels) => {
  const levelsMatrix = Array(5).fill(null).map((_, i) => {
    const lowerIdx = Math.floor((rawLevels.length / 5) * i)
    const upperIdx = Math.floor((rawLevels.length / 5) * (i + 1))
    return rawLevels.slice(lowerIdx, upperIdx)
  })

  // Used `for` instead of mapping for performance reasons
  const levels = []
  for (let i = 0; i < levelsMatrix.length; i++) {
    const row = levelsMatrix[i]
    let sum = 0
    for (let j = 0; j < row.length; j++) { sum += row[j] }
    levels[i] = clampOnScale(sum / row.length)
  }

  return levels
}



// Never written to: the sampler replaces it before the first read.
const emptyData = new Uint8Array()

// One of `audioTrack` or `mediaStream` is expected (the old custom PropTypes
// validator only logged in development, and React 19 no longer runs it).







// Was a plain class component (no memo, as before). The sampler, audio
// context and analyser are instance fields (refs); the levels are painted
// straight onto the bars, outside React. Lifecycle work runs in layout
// effects, like componentDidMount/DidUpdate/WillUnmount.
const SoundAmplitude = (props) => {
  const { className } = props
  // `this.props` for the lifecycle helpers (updated before any effect runs).
  const latestProps = _react.useRef.call(void 0, props)
  _react.useInsertionEffect.call(void 0, () => { latestProps.current = props })

  const samplingInterval = _react.useRef(undefined)
  const audioCtx = _react.useRef(null)
  const analyser = _react.useRef(null)
  const dataArray = _react.useRef(emptyData)
  const rootRef = _react.useRef(null)
  const prevProps = _react.useRef(null)

  const setRootRef = _react.useCallback.call(void 0, (r) => { rootRef.current = r }, [])

  const renderLevels = _react.useCallback.call(void 0, (levels) => rootRef.current &&
    requestAnimationFrame(() =>
      rootRef.current && rootRef.current.childNodes &&
      rootRef.current.childNodes.forEach((n, i) => {
        const t = `scaleY(${Math.max(levels[i], 0.1)})`
        // SAFETY: the root's children are the five bar <div>s rendered below.
        const { style } = n 
        style.transform = t
        style.webkitTransform = t
      },
      ),
    ), [])

  const closeAudioCtx = _react.useCallback.call(void 0, () => audioCtx.current && audioCtx.current.close(), [])
  const stopSampler = _react.useCallback.call(void 0, () => clearInterval(samplingInterval.current), [])

  const initSampler = _react.useCallback.call(void 0, () => {
    const {
      mediaStream: givenStream,
      audioTrack: givenTrack,
    } = latestProps.current

    closeAudioCtx()

    const audioTrack = givenTrack ||
      (givenStream && givenStream.getAudioTracks()[0])

    // SAFETY: the prefixed constructor is optional on Window; with neither
    // present `new` throws, as in JS.
    const AudioContextCtor = (window.AudioContext || (window ).webkitAudioContext)
    audioCtx.current = new AudioContextCtor()
    if (!audioCtx.current || !audioTrack) return

    const mediaStream = new MediaStream([audioTrack])
    const source = audioCtx.current.createMediaStreamSource(mediaStream)
    analyser.current = audioCtx.current.createAnalyser()

    source.connect(analyser.current)

    analyser.current.fftSize = 32
    const bufferLength = analyser.current.fftSize
    dataArray.current = new Uint8Array(bufferLength)
  }, [closeAudioCtx])

  const sample = _react.useCallback.call(void 0, () => {
    // Throws while there is no analyser; the sampler catches it and stops.
    analyser.current.getByteTimeDomainData(dataArray.current)
    const rawLevels = []
    for (let i = 0; i < dataArray.current.length; i++) {
      rawLevels[i] = 10 * Math.abs(
        (dataArray.current[i] - 128) / 128,
      )
    }

    const levels = parseRawLevels(rawLevels)
    renderLevels(levels)
  }, [renderLevels])

  const startSampler = _react.useCallback.call(void 0, () => {
    if (analyser.current) {
      samplingInterval.current = setInterval(() => {
        try { sample() } catch (e) { stopSampler() }
      }, 200)
    }
  }, [sample, stopSampler])

  const startRandomSampler = _react.useCallback.call(void 0, () => {
    samplingInterval.current = setInterval(() => {
      renderLevels(Array(5).fill(0).map(Math.random))
    }, 300)
  }, [renderLevels])

  // componentDidMount (first run) / componentDidUpdate (every later render)
  _react.useLayoutEffect.call(void 0, () => {
    const prev = prevProps.current
    const { audioTrack, mediaStream, isAlwaysActive } = latestProps.current
    prevProps.current = latestProps.current

    if (!prev) {
      if (isAlwaysActive) { startRandomSampler(); return }
      initSampler()
      startSampler()
      return
    }

    if (!audioTrack && !mediaStream) { stopSampler(); return }
    if (
      prev.audioTrack !== audioTrack ||
      prev.mediaStream !== mediaStream
    ) {
      stopSampler()
      initSampler()
      startSampler()
    }
  })

  // componentWillUnmount
  _react.useLayoutEffect.call(void 0, () => () => {
    closeAudioCtx()
    stopSampler()
  }, [closeAudioCtx, stopSampler])

  const rootClassName = _classBuilder2.default.call(void 0, "video-call--sound-amp", className)

  return (
    _react2.default.createElement('div', { className: rootClassName, ref: setRootRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 165}}
      , _react2.default.createElement('div', { className: "video-call--sound-amp-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 166}} )
      , _react2.default.createElement('div', { className: "video-call--sound-amp-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 167}} )
      , _react2.default.createElement('div', { className: "video-call--sound-amp-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 168}} )
      , _react2.default.createElement('div', { className: "video-call--sound-amp-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}} )
      , _react2.default.createElement('div', { className: "video-call--sound-amp-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}} )
    )
  )
}

exports. default = SoundAmplitude
